<template>
  <el-table class="docutax-request-table" ref="docutaxRequestsTable" stripe :data="filteredRequests" style="width: 100%"
    :default-sort="{ prop: 'createdDate', order: 'descending' }">
    <el-table-column property="officeId" label="Office" width="90" sortable>
      <template slot-scope="{ row }">{{ getUserIdForOffice(row.officeId) }}</template>
    </el-table-column>
    <el-table-column property="assignedPreparerName" width="170" label="Preparer" sortable />
    <el-table-column v-if="showClientColumn" property="clientName" label="Client Name" sortable>
      <template slot-scope="{ row }">
        <p class="ma-0">{{ row.clientName }}</p>
        <p class="ma-0"><small>{{ row.clientCellPhone }}</small></p>
        <p class="ma-0"><small>{{ row.clientEmailAddress }}</small></p>
        <el-link icon="el-icon-user-solid" type="primary" @click="navigateToClientProfile(row)">View
          Profile</el-link><br />
        <el-link icon="el-icon-s-promotion" type="primary" @click="onSendRequest(row)">Send New Request</el-link>
      </template>
    </el-table-column>
    <el-table-column property="message" label="Message" min-width="120" />
    <el-table-column property="hasResponded" label="Has Responded?" min-width="80">
      <template slot-scope="{ row }">
        {{ row.hasResponded ? 'Yes' : 'No' }}
      </template>
    </el-table-column>
    <el-table-column property="createdDate" label="Created" width="110" sortable>
      <template slot-scope="{ row }">{{ formatDate(row.createdDate) }}</template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'DocutaxRequestsTable',
  props: {
    requests: {
      type: Array,
      default: () => [],
    },
    showClientColumn: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions('Lookup', ['getOffices']),
    formatDate(date) {
      return moment(date).format('L LT');
    },
    getUserIdForOffice(id) {
      return (this.officeMap[id] ? this.officeMap[id].userId : '');
    },
    onSendRequest(row) {
      this.$emit('sendRequest', row);
    },
    navigateToClientProfile(row) {
      this.$router.push({ name: 'docutaxClientProfile', params: { clientId: row.clientId } });
    },
  },
  computed: {
    ...mapGetters('User', [
      'isManager',
      'user',
    ]),
    ...mapGetters('Lookup', [
      'officeMap',
    ]),
    filteredRequests() {
      return this.requests;
    },
  },
  mounted() {
    this.getOffices();
  },
};

</script>

<style lang="scss" scoped>
.client-header {
  h2 {
    margin: 0;
    padding: 0 5px;
    font-size: 1.8em;

    span {
      font-weight: normal;
      color: #999;
      font-size: 0.75em;
      text-transform: uppercase;
    }
  }
}

.editable-tag {
  cursor: pointer;
}

.documents-column {
  .el-button {
    padding-bottom: 0;
  }

  .el-button:disabled {
    cursor: default;
  }

  .el-button+.el-button {
    margin-left: 0;
  }
}
</style>
